import { render } from "./NamecardManageDetails.vue?vue&type=template&id=5d48548b"
import script from "./NamecardManageDetails.vue?vue&type=script&lang=js"
export * from "./NamecardManageDetails.vue?vue&type=script&lang=js"

import "./NamecardManageDetails.vue?vue&type=style&index=0&id=5d48548b&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__